module.exports = __webpack_public_path__ + "static/cubes_2-96a226d5755194d98c2f158711db99e1.mp4";